/**
 * WebGPU/TSL runtime world-space normal material matching
 * {@link MeshWorldSpaceNormalMaterial} on top of {@link MeshBasicNodeMaterial}.
 */

import { normalWorld, vec4 } from 'three/tsl';
import { MeshBasicNodeMaterial } from 'three/webgpu';

/**
 * Node material counterpart to `MaterialUtils.MeshWorldSpaceNormalMaterial`.
 * Outputs world-space normals remapped to [0, 1] for debugging.
 * Not serialized — instantiated only by the renderer node library.
 */
export class GenesysWorldNormalNodeMaterial extends MeshBasicNodeMaterial {
  constructor() {
    super();
    this.name = 'GenesysWorldNormalNodeMaterial';
    this.fragmentNode = vec4(normalWorld.mul(0.5).add(0.5), 1.0);
  }
}
